function defaultGetExpToNextLevel(currentLevel: number) {
  return Math.ceil(1.2 ** currentLevel - 1);
}

export function getLevelInfo(
  exp: number,
  getExpToNextLevel = defaultGetExpToNextLevel,
) {
  let level = 1;
  let remainingExp = exp;
  let expToNextLevel = getExpToNextLevel(level);
  let totalExpToNextLevel = expToNextLevel;

  while (remainingExp >= expToNextLevel) {
    remainingExp -= expToNextLevel;
    level++;
    expToNextLevel = getExpToNextLevel(level);
    totalExpToNextLevel += expToNextLevel;
  }

  return {
    level,
    totalExpToNextLevel,
    expToNextLevel,
    currentExp: remainingExp,
    progress: (remainingExp / expToNextLevel) * 100,
  };
}
